import React from 'react';
import mom_baby from '../../../assets/images/educational_service/mom_baby.jpg';
import members from '../../../assets/images/educational_service/members.jpg';
import { motion } from 'framer-motion';

const EducationalTestimonials = () => {
  const TitleAndDescription = ({ said, description }) => {
    return (
      <div className="flex flex-col gap-1">
        <p
          className="text-lg md:text-xl italic font-semibold text-pink  leading-6 max-w-auto "
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <p className="flex relative justify-end right-12 text-lg font-semibold text-secondary">
          {said}
        </p>
      </div>
    );
  };

  return (
    <section className="bg-[#E7E8E8]">
      <div className="relative w-full max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 z-10">
        <div className="mb-8">
          <h1 className="text-[38px] sm:text-[40px] md:text-[54px] text-primary font-bold">
            Testimonials
          </h1>
        </div>
        <div className="flex flex-col gap-10">
          <div className="flex flex-col md:flex-row gap-10 md:gap-48">
            <div className="flex-1 flex flex-col gap-4 sm:gap-10">
              <TitleAndDescription description='"Susan is the most amazing upbeat educator I’ve ever met! She’s always striving to help students in new ways, and to get them excited about learning. She is kind and gentle, knowledgeable and experienced in helping kids better themselves." ' />
              <TitleAndDescription description='""Guidepost Pediatrics has taken my son under their knowledgeable and kind wings. He attends tutoring with Susan and OT with Dr. Blossom, and both have been positive aspects of my son’s education."' />
              <TitleAndDescription
                said="⎯ &nbsp;&nbsp;Gage C. August 2023"
                description='"My daughter loves going to her appointments and looks forward to them every week. They’ve done a wonderful job with her including offering me ideas and guidance to use at home. I highly recommend Guidepost for speech, OT, and PT."'
              />
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1, ease: 'easeOut' }}
                viewport={{ once: true, amount: 0.5 }}
              >
                <img
                  src={mom_baby}
                  alt="Pediatric therapy group session in Wasilla clinic"
                  className="rounded-3xl"
                />
              </motion.div>
            </div>
            <div className="flex-1 flex flex-col gap-4 sm:gap-10">
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1, ease: 'easeOut' }}
                viewport={{ once: true, amount: 0.5 }}
              >
                <img
                  src={members}
                  alt="Physical therapist assisting child in Wasilla clinic"
                  className="rounded-3xl mt-20 md:mt-auto"
                />
              </motion.div>
              <TitleAndDescription
                said="⎯ &nbsp;&nbsp;June 2022 - Rachel M."
                description='"We had been on numerous waitlist for an entire year. Guidepost Pediatrics worked us in the week of the referral. We were evaluated a week later and immediately put on a regular schedule. Speaking as a military family, Guidepost did an amazing job at accommodating our unique needs."'
              />
              <TitleAndDescription
                said="⎯ &nbsp;&nbsp;Sara V. Homeschool Parent"
                description='"Bringing Guidepost services into our lives has been absolutely incredible. Susan instantly connected with our three girls 9,10,12. She immediately pinpointed and brought focus to areas they were struggling, areas where they are excelling and areas where they need more of a challenge. Her clear communication and expectations bring ease to the entire process. She has become a person of accountability and encouragement to our girls and it has lifted the burden off of us and allowed us to shift back into being Mom and Dad and a little less teacher. The shift was immediately apparent in our household and feels so amazing. The girls are excited to learn and so eager to share with her what they have planned for the day. My girls describe Susan as “encouraging, joy filled, sweet and a very happy person” and I agree wholeheartedly. "'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationalTestimonials;
